/* eslint-disable tailwindcss/no-custom-classname */

import type { PropsOf } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';
import classnames from 'classnames';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';
import { useToastStyles } from '../Toast/Toast.context';

export type ToastFooterProps = OmitChakraProps<PropsOf<'footer'>>;

export const ToastFooter = withChakraAs<ToastFooterProps, 'footer'>(
  ({ className, ...props }) => {
    const styles = useToastStyles();

    return (
      <chakra.footer
        {...props}
        className={classnames('toast-footer', className)}
        __css={styles.footer}
      />
    );
  },
);
